// extracted by mini-css-extract-plugin
export default {"notification-badge":"M2SQp3J","notification-badge--has-value":"xDs6i1f"};